import ko from 'knockout';

export default class ViewModel {
  constructor(options = {
    Amount: '',
    isEditing: false,
    AccountCurrencyCode: '',
  }) {
    this.amount = ko.observable(options.Amount);
    this.accountCurrencyCode = options.AccountCurrencyCode;
    this.isEditing = ko.observable(options.isEditing);
  }
}
